// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"vj-z","carouselContainer":"wj-z","carouselContent":"xj-z"};